var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.6276C18.4025 21.6276 17.0975 20.3301 17.0975 18.7251C17.0975 17.1201 18.4025 15.8301 20 15.8301C21.5975 15.8301 22.9025 17.1276 22.9025 18.7326C22.9025 20.3376 21.5975 21.6276 20 21.6276ZM20 16.9551C19.025 16.9551 18.2225 17.7501 18.2225 18.7326C18.2225 19.7151 19.0175 20.5101 20 20.5101C20.9825 20.5101 21.7775 19.7151 21.7775 18.7326C21.7775 17.7501 20.975 16.9551 20 16.9551Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.07C18.89 28.07 17.7725 27.65 16.9025 26.8175C14.69 24.6875 12.245 21.29 13.1675 17.2475C14 13.58 17.2025 11.9375 20 11.9375C20 11.9375 20 11.9375 20.0075 11.9375C22.805 11.9375 26.0075 13.58 26.84 17.255C27.755 21.2975 25.31 24.6875 23.0975 26.8175C22.2275 27.65 21.11 28.07 20 28.07ZM20 13.0625C17.8175 13.0625 15.0125 14.225 14.27 17.495C13.46 21.0275 15.68 24.0725 17.69 26C18.9875 27.2525 21.02 27.2525 22.3175 26C24.32 24.0725 26.54 21.0275 25.745 17.495C24.995 14.225 22.1825 13.0625 20 13.0625Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSettingsIcon);
export default __webpack_public_path__ + "static/media/location-settings-icon.53180cf2a8af4953f8e5c8ae88ffd3c4.svg";
export { ForwardRef as ReactComponent };